import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import App from './App.tsx';
import './index.css';

// Silence all WebSocket errors globally - they're not critical
const originalConsoleError = console.error;
const originalConsoleWarn = console.warn;

console.error = (...args: any[]) => {
  const message = args[0]?.toString?.() || '';
  if (message.includes('WebSocket') || message.includes('insecure')) return;
  originalConsoleError(...args);
};

console.warn = (...args: any[]) => {
  const message = args[0]?.toString?.() || '';
  if (message.includes('WebSocket') || message.includes('insecure')) return;
  originalConsoleWarn(...args);
};

window.addEventListener('error', (event) => {
  if (event.message?.includes('WebSocket') || event.message?.includes('insecure')) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    return false;
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const message = event.reason?.message || event.reason?.toString() || '';
  if (message.includes('WebSocket') || message.includes('insecure')) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    return false;
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);
